import React from "react";
import UlLi, { scrollTo, mountCode, initDeepLinkData, urlChangeHandler } from "js/utilities/sdk-doc-utils";
import { Grid, Row, Col, Table, Label, Glyphicon } from "react-bootstrap";
import Highlight from "react-highlight";
import { Navigation, Link } from "react-router";
import CodeBlocks from "js/utilities/sdk-doc-code-blocks";
import UserHandler from "js/utilities/user-handler";
import { ZOOM_ICON } from "js/config.jsx";
import SDKSidebar from "js/utilities/sdk-sidebar"
import ZOOM_MAP from "resources/img/zoom_map.png";

export default React.createClass({
  displayName: "usability-and-success",
  scrollToGuide: null,
  scrollingEl: null,
  getInitialState: function () {
    var data = [{ name: "FaceTec User Experience Details" }
    ];

    var scrollToElement = initDeepLinkData(this.props);

    return {
      data,
      navMenuParent: null,
      navMenu: null,
      scrollToElement: scrollToElement,
      isMobile: false
    };
  },

  componentDidMount: function () {
    mountCode(this);
    this.setState({isMobile: window.innerWidth <= 760});
  },

  componentWillMount() {
    window.addEventListener('popstate', this.urlChanged, false)
  },

  urlChanged() {
    urlChangeHandler();
  },

  render: function () {

    if (this.scrollToGuide && this.scrollingEl)
      scrollTo(this.scrollingEl, this.scrollToGuide);
    this.scrollToGuide = null;

    return (
      <div>
        <div className="dash">
          <div className="workspace">
            <div className="workspace__container">

              <section>
                <div className="title">
                  <Glyphicon glyph="list" />
                  <h2 id="usability-and-success-rates">Bias & Success Rates</h2>
                </div>
                <p>Learn about how user success is measured, and how FaceTec SDKs achieve cutting edge performance in diverse populations.</p>
                <hr/>
              </section>

              <section>
                <div className="row">
                  <div className={this.state.isMobile == true? "col-xs-12" : "col-xs-6"}>
                    <h3 id="zoom-training-set-diversity">FaceTec Training Set Diversity</h3>


                    <p><strong>FaceTec has Customers & Partners on 6 continents</strong>, including many in Africa, Asia, India and several European nations, who have all performed exhaustive due diligence with their local populations before signing long-term contracts to use FaceTec SDKs.</p>
                    <p><strong>Our training set consists of millions of 3D FaceMaps</strong> from users all over the world, with every compatible iOS devices ever made, over 5,000 Android devices, and many thousands of webcam models.</p>
                    <p><strong>Each month, nearly 3 million new users create accounts with FaceTec at ~97%-99% first-time user success rates</strong>, and we continue to work diligently to achieving higher levels in every aspect of security and usability.</p>
                  </div>

                  <div className={this.state.isMobile == true? "col-xs-12" :"col-xs-6 splitSectionBorder"}>
                    <p style={{textAlign: "center"}}><img src={ZOOM_MAP} style={{marginTop: "40px", marginBottom: "40px", maxWidth: "100%", maxHeight: "300px"}} /></p>
                  </div>
                </div>
              </section>

              <hr />

              <section>
                <div>
                  <h3 id="first-time-user-success-rates">First-time User Success Rates</h3>
                  <p>~90% - Prove Liveness on their very first Session.</p>
                  <p>~5% - Perform an unsuccessful User Session their first try, and are shown guidance screens and succeed on their second session.</p>
                  <p>~3% - Perform an unsuccessful User Session again, see more guidance screens and then succeed on sessions 3-5.</p>
                  <p>The remaining 1-2% consist of: legitimate Spoof attacks, people who are wearing sunglasses and won't take them off, users who quit the process.</p>
                  <p>High-end devices with better frame rates and better imaging sensors do skew slightly higher, but over millions of real-world sessions we do not observe significantly different performance on low end devices.</p>
                </div>
                <br/>
              </section>

              <hr />

              <section>
                <div>
                  <h3 id="usability-with-light-skin-tones">Usability with Light Skin Tones</h3>
                  <p>Smartphone camera sensors need light to function. However, if too much light is reflected back to the sensor the camera will not work well. As a result of this, people with lighter skin tones and too much light present in their environment may appear "blown-out" to the camera. This can occur in direct sunlight or other extremely bright environments. However, making a 90-degree turn will usually change the directional lighting enough for the sensor to function properly. With a camera sensor that is not over-saturated, FaceTec has no difference in performance over the spectrum of skin tones.</p>
                </div>
                <br/>
              </section>

              <hr />

              <section>
                <div>
                  <h3 id="usability-with-dark-skin-tones">Usability with Dark Skin Tones</h3>
                  <p>Smartphone camera sensors need light to function. If there isn't enough light reflected back to the sensor, the camera will not work well. As a result of this, people with darker skin tones must have more light present in their environment than those with lighter skin tones. However, with sufficient lighting for the specific camera sensor, FaceTec has no difference in performance over the spectrum of skin tones.</p>
                </div>
                <br/>
              </section>

              <hr />

              <section>
                <div>
                  <h4 id="maintaining-a-real-world-perspective-during-your-due-diligence">Maintaining a Real-World Perspective During Your Due Diligence</h4>
                  <p>Typically, the first time anyone uses FaceTec it just works. It's easy, fast and simple, and once it's done the users just move on with their lives. However, Developers immediately enter into "test mode" and start turning off lights, pointing the camera into direct sunlight, trying different angles, blocking parts of their faces, etc.</p>
                  <p>Developers who are tasked with usability testing should push the limits of FaceTec SDKs, but they should not let those experiences incorrectly shape their overall perspective. Just as users would not try to type their complex passwords while taking off in an airplane or in a bumpy subway car, nor do users demand that FaceTec work during a laser light show in a night club.</p>
                  <p>Real users just need FaceTec SDKs to work under their normal conditions so they can get through the process and continue on with their lives. Almost everyone agrees that FaceTec SDKs are super easy to use and presents much less friction than a password. So please don't let extreme usability testing incorrectly skew your perspective! Put yourself in the mindset of the millions of first-time FaceTec users who have successfully opened new accounts and now access them daily without any problems, and who never ever want to go back to a bank branch or passwords.</p>
                </div>
                <br/>
              </section>

              <hr />

              <section>
                <div>
                  <h4 id="i-am-zooming-in-a-challenging-environment-repeatedly-but-zomm-is-not-working">"I'm Performing a Session in a Challenging Environment Repeatedly, but FaceTec SDKs are not working."</h4>
                  <p>FaceTec SDKs are designed to work in the real world. FaceTec SDK on-screen instructions guide new users to perform successful sessions that prove their 3D Liveness. FaceTec SDKs achieve 96-99% real-world first time user success because even if the user has to retry, they will likely pass seconds later on a subsequent attempt after seeing the Retry Screen and correcting their environment.</p>
                  <p><strong>Real end users *want* FaceTec SDKs to work on themselves</strong>, and will follow on-screen help instructions. </p>
                  <p><strong>Unlike this test case, Real end users DO NOT seek challenging environments and repeatedly try User Sessions from those environments without changing anything</strong>.  FaceTec works in a wide variety of challenging environments, but if you are seeing the Retry Screen, you need to check out your photo next to the Good Example Photo.  If your photo shows glare or data loss, you need to fix it, like a real user would.</p>
                </div>
                <br/>
              </section>

              <hr />

              <section>
                <div>
                  <h4 id="accessibility">Accessibility with Atypical Facial Conditions</h4>
                  <p>FaceTec makes every effort to ensure its Liveness Detection and Face Authentication Software work perfectly for as many members of the global population as possible. Even though there are no observable biases in FaceTec's algorithms across the spectrum of typical human skin tones, because the AI models the user's face in 3D, and is trained on a large, global dataset (170+ countries, and millions of records), the AI can still encounter challenges making Liveness decisions on atypical human faces. Atypical traits that may influence the AI include: objects that obfuscate the face, such as eye patches or prosthetics, birth conditions, and/or conditions that include partial or whole facial paralysis, scarring from burns, other incidents that have left a lasting effect on the facial structure, or skin conditions. Our AI training sets do include some of these conditions; however, with unlimited combinations of these atypical traits, these are cases where our AI is unable to make a confident Liveness decision due to these variables. Users with atypical facial features may experience a higher False Reject Rate and potentially the inability to successfully prove Liveness with the FaceTec SDKs.</p>
                  <p>We recommend that our Customers provide a support channel with a manual review process specifically for users with atypical facial features and that agents manually review the user's audit trail images to make an informed decision about whether or not to allow the individual to proceed to their desired digital destination if, after five attempts, the FaceTec AI is unable to make a positive Liveness determination.</p>
                </div>
                <br/>
              </section>

              <hr />

              <section>
                <div>
                  <h4 id="accessibility-visual-impairment">Blind & Visually Impaired Users</h4>
                  <p>FaceTec's iOS, Android, and Browser SDKs are designed to be compatible and accessible with screen readers.</p>
                  <p>Users who are severely visually impaired, partially or fully blind, may enlist another person to hold the device for them, perform the button presses, and guide them through the Video Selfie capture process. The only requirement is that the visually impaired user User must have their eyes open.</p>
                </div>
                <br/>
              </section>



              <SDKSidebar menuType="main" title="FaceTec User Experience Details" />

            </div>
          </div>
        </div>
      </div>
    );
  }

});



// WEBPACK FOOTER //
// ./src/js/components/screens/zoom-user-experience-details.jsx